module.exports = __webpack_public_path__ + "static/media/event-friends-iphonex-favourites.7589b186.jpg";